const numberValue = (theNumber: number): number => {
    const value = Math.round(theNumber || 0);
    return isFinite(value) ? value : 0;
};

export default numberValue;